function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.349,
    height: 31.682,
    viewBox: "0 0 27.349 31.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10247"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 48",
    d: "M2.1 26.049a2.1 2.1 0 0 1-2.1-2.1V2.1A2.1 2.1 0 0 1 2.1 0h13.4c3.2 0 6.211 3.473 6.211 6.16v17.793a2.1 2.1 0 0 1-2.1 2.1z",
    transform: "translate(2.817 2.814)",
    style: {
      fill: "#175664",
      stroke: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6633",
    d: "m5461.433 6534.647 2.667 2.676 6.373-6.505",
    transform: "translate(-5452.8 -6516.75)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 14",
    d: "M22.434 31.682H4.908A4.918 4.918 0 0 1 0 26.766V4.916A4.918 4.918 0 0 1 4.908 0H18.32a8.816 8.816 0 0 1 6.406 3 9.154 9.154 0 0 1 2.621 5.969v17.797a4.921 4.921 0 0 1-4.913 4.916zM4.908 2.705A2.212 2.212 0 0 0 2.7 4.916v21.85a2.212 2.212 0 0 0 2.21 2.211h17.524a2.213 2.213 0 0 0 2.214-2.211V11.459h-3.374a5.475 5.475 0 0 1-5.462-5.475V2.705zm13.662 0v3.279a2.71 2.71 0 0 0 2.7 2.711h3.363l-.015-.129c-.254-2.5-2.9-5.6-5.926-5.848z",
    transform: "translate(.001)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDone);
export default __webpack_public_path__ + "static/media/file_done.bdc4f6b3.svg";
export { ForwardRef as ReactComponent };